export const getMediaUrl = (file) => {
  if (!file) return "";

  const value = String(file).trim();
  if (!value) return "";
  if (/^https?:\/\//i.test(value)) return value;

  const uploadBase =
    process.env.REACT_APP_BACKEND_URL_REL ||
    `${process.env.REACT_APP_BACKEND || "http://localhost:8001/"}uploads/`;

  const base = uploadBase.endsWith("/") ? uploadBase : `${uploadBase}/`;
  const cleanFile = value.replace(/^\/+/, "").replace(/^uploads\//i, "");

  return `${base}${cleanFile}`;
};
